import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { DropdownComponent } from '../../ui/dropdown/dropdown.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DropdownItemTwoComponent } from '../../ui/dropdown/dropdown-item/dropdown-item.component-two';
import { ApplicationStore } from '@core/stores/application.store';
import { KeycloakService } from '@core/services/keycloak.service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-user-dropdown',
  templateUrl: './user-dropdown.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    RouterModule,
    TranslatePipe,
    DropdownComponent,
    DropdownItemTwoComponent
  ]
})
export class UserDropdownComponent {
  readonly applicationStore = inject(ApplicationStore);
  readonly keycloakService = inject(KeycloakService);

  isOpen = false;

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  closeDropdown() {
    this.isOpen = false;
  }

  async logout() {
    await this.keycloakService.logout();
  }
}
